import React from "react";

const ConfirmationModal = ({ title, message, onConfirm, onCancel }) => {
  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-justify-center tw-items-center tw-bg-black tw-bg-opacity-50 tw-z-50">
      <div className="tw-bg-white tw-rounded-lg tw-shadow-xl tw-p-6 tw-w-full tw-max-w-md">
        <h3 className="tw-text-lg tw-font-medium tw-mb-2">{title}</h3>
        <p className="tw-text-gray-600 tw-mb-6">{message}</p>
        <div className="tw-flex tw-justify-end tw-space-x-4">
          <button
            onClick={onCancel}
            className="tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-gray-700 hover:tw-bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="tw-px-4 tw-py-2 tw-bg-red-600 tw-text-white tw-rounded-md hover:tw-bg-red-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;